import React, { Component } from "react";
import Tooltip from "../../components/UI/TooltipIcon/TooptipIcon";
import orderBy from "lodash/orderBy";
import { withRouter } from "react-router-dom";
import DaniIcon from "./../../assets/dani_icon.svg";
import slackLogo from "../../assets/icons/Slack-Small.png";
import teamsLogo from "../../assets/icons/Teams-Small.png";
import moment from "moment";
import { toastContainer } from "../../utils/toast";
import { marked } from "marked";
import parse from "html-react-parser";
import {
  Modal,
  ModalBody,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Popover,
  PopoverHeader,
  PopoverBody,
  Row,
  Col,
  ModalHeader,
} from "reactstrap";
import { IoChatboxOutline } from "react-icons/io5";
import { connect } from "react-redux";
import reply from "../../assets/stories/reply.svg";
import likeHover from "../../assets/stories/likes_hover.svg";
import Select from "react-select";
import "rc-checkbox/assets/index.css";
import { BiDotsHorizontalRounded, BiShare, BiMailSend } from "react-icons/bi";
import { isMobile, isMobileDevice } from "../../utils/deviceInfo";
import UserIcon4 from "../../assets/user-image-plc/User_Icon_4.svg";
import {
  storyReactions,
  storyTemplates,
  createUrlLink,
  createMentionUrl,
  matchUrl,
  checkUploadType,
  uploadPreview,
  wordFilter,
  checkValidityForAnonymousToggleEdit,
  renderGenderPronoun,
  profilePicValidityCheck,
} from "../../utils/constants";
import { MentionsInput, Mention } from "react-mentions";
import "./Stories.css";
import Loading from "../../hoc/Loading/Loading";
import Reactions from "./Reactions.jsx";
import StoryCommentList from "./StoryCommentList.jsx";
import defaultStyle from "./defaultStyle";
import defaultMobileStyle from "./defaultMobileStyle";
import defaultMentionStyle from "./defaultMentionStyle";
import classNames from "./Stories.css";
import Toggle from "react-toggle";
import axios from "../../axios";
import * as url from "../../utils/url";
import * as actionCreators from "../../modules/actions/index";
import { ListGroup, ListGroupItem } from "reactstrap";
import avatarIcon from "../../assets/default-avatar.png";
import ShowMore from "react-show-more";
import PlaceholderStories from "./PlaceholderStories";
import If from "../../components/Shared/If";
import classnames from "classnames";
import get from "lodash/get";
import filter from "lodash/filter";
import downArrowImg from "../../assets/arrow-down.svg";
import ReactPlayer from "react-player/lazy";
import StoriesPhotoGrid from "./StoriesPhotoGrid";
import StoriesPhotoCarousel from "./StoriesPhotoCarousel";
import StoryMentionsText from "../../components/CreateStory/StoryMentionsText";
import StoryCatsMobile from "./StoryCatsMobile";
import SingleStory from "./SingleStory";
import EditStory from "../../components/CreateStory/EditStory";
import ReportStoryModal from "./ReportStoryModal";
import { isEmpty } from "lodash";
import SlackSharePopup from "../../components/SlackAndTeamsPopups/SlackSharePopup";
import TeamsSharePopup from "../../components/SlackAndTeamsPopups/TeamsSharePopup";
import TurndownService from "turndown";
import { gfm } from "turndown-plugin-gfm";
import ShareStory from "../../components/ShareEntity/ShareEntity";

class StoryItems extends Component {
  constructor(props) {
    super(props);
    const hideAnonymous =
      props.user.profile && props.user.profile.organizationId.disableAnonymity
        ? checkValidityForAnonymousToggleEdit(
            props.item.createdOn,
            props.item.isAnonymous,
            "cultureApp",
            props.user.profile.organizationId.disableAnonymity
          )
        : false;

    this.state = {
      stories: [],
      archievedStories: [],
      privacy: "PUBLIC",
      isAnonymous: false,
      isAnonymousVisible: !hideAnonymous,
      disableSubmit: true,
      showReplies: false,
      mentionsSelected: [],
      mentionsFound: [],
      ogp: {
        urlScrape: false,
        requestUrl: "",
        // urlScrape:false,
        // ogImage:"",
        // ogDesc:"",
        // ogTitle:"",
        // ogType:"",
        // ogUrl:"",
        // ogSiteName:"",
        // extra:{}
      },
      showResponses: [],
      isCommentsOpen: false,
      responseCounter:
        this.props && this.props.item && this.props.item.storyCounter,
      disableSubmit: true,
      showUserReactions: false,
      showReactions: null,
      storyType: "Story",
      reactionCounter:
        this.props &&
        this.props.item &&
        this.props.item.reactionArr &&
        this.props.item.reactionArr.reactions &&
        this.props.item.reactionArr.reactions.length > 0
          ? this.props.item.reactionArr.reactions.length
          : 0,
      reactionList:
        this.props &&
        this.props.item &&
        this.props.item.reactionArr &&
        this.props.item.reactionArr.reactions &&
        this.props.item.reactionArr.reactions.length > 0
          ? this.props.item.reactionArr.reactions.slice(0, 3)
          : [],
      userReacted:
        this.props &&
        this.props.item &&
        this.props.item.reactionArr &&
        this.props.item.reactionArr.reactions &&
        this.props.item.reactionArr.reactions.length > 0
          ? this.props.item.reactionArr.reactions.filter((e) => {
              return e.userId === this.props.user.profile._id;
            })
          : "null",
      mentionWord: "",
      userReactions: [],
      description: {
        value: "",
        error: false,
      },
      isRemoved: false,
      response: "",
      mentionBool: false,
      mentionsIndex: 0,
      carouselData: [],
      setImagesPreview: [],
      rejectedFiles: [],
      dropdownOpen: false,
      title: "",
      isVideo:
        this.props &&
        this.props.item &&
        this.props.item.ogp &&
        this.props.item.ogp.ogType &&
        this.props.item.ogp.ogType.indexOf("video") > -1
          ? true
          : false,
      showCreateStoryModal: false,
      modalActionType: "Create",
      categoryDefinitionPopoverOpen: false,
      collapseCompleted: true,
      showRemoveFeedConfirmationModal: false,
      storyIdRemove: "",
      showStoryDetailsPopup: false,
      storyDetailsPopupPath: "",
      singleStoryPopupId: null,
      editPopupOpen: false,
      editStoryPopupObj: null,
    };
    // console.log(this.props)
  }

  openStoryEditPopup = (id) => {
    this.setState({
      editPopupOpen: true,
      editStoryPopupObj: id,
    });
  };

  closeStoryEditPopup = () => {
    this.setState({
      editPopupOpen: false,
      editStoryPopupObj: null,
    });
  };

  onStoryEditSuccess = (editedStory) => {
    // Update here on Story success edits
    console.log("1111111");
    if (this.props.editParticularStoryobj) {
      console.log("2222222");
      this.props.editParticularStoryobj(editedStory);
    }
  };

  toggleStoryDetailsPopup = () => {
    if (this.state.showStoryDetailsPopup) {
      this.setState({ storyDetailsPopupPath: "", singleStoryPopupId: null });
    }
    this.setState({ showStoryDetailsPopup: !this.state.showStoryDetailsPopup });
  };

  toggleDropdown = (id) => {
    let { dropdownOpen } = this.state;
    if (dropdownOpen === id) {
      this.setState({ dropdownOpen: "" });
    } else {
      this.setState({ dropdownOpen: id });
    }
  };

  fileSelectedHandler = (e) => {
    let { setImagesPreview } = this.state;
    this.setState({ imageError: null });
    if (e.target.files) {
      let arr = [];
      let fileArr = Array.from(e.target.files).map((file, idx) => {
        let obj = {
          name: file.name,
          type: file.type,
          size: file.size,
          file,
          preview: URL.createObjectURL(file),
          isAccepted: checkUploadType(file.type),
        };
        return uploadPreview(obj);
      });

      let acceptedFiles = fileArr.filter((e) => e.isAccepted == true);
      //   .map(e=>{
      // 	delete e.isAccepted
      // 	return e
      //   })
      let rejectedFiles = fileArr.filter((e) => e.isAccepted == false);
      let allUploads = acceptedFiles.concat(rejectedFiles);

      let acceptedLength = setImagesPreview.length + acceptedFiles.length;
      if (acceptedLength < 6) {
        this.setState((prevState) => ({
          setImagesPreview: prevState.setImagesPreview.concat(acceptedFiles),
          rejectedFiles: prevState.rejectedFiles.concat(rejectedFiles),
        }));
        Array.from(e.target.files).map((file) => URL.revokeObjectURL(file));
      } else {
        this.setState({
          imageError: 2,
        });
      }
    }
  };

  renderUploadPreview = (source) => {
    let { rejectedFiles } = this.state;

    return source.map((photo, idx) => {
      let { preview, size } = photo;
      let mb = 1024 * 1024;
      let file_size =
        size >= mb
          ? `${(size / mb).toFixed(2)}mb`
          : `${(size / 1024).toFixed(2)}kb`;
      return (
        <span
          key={idx}
          className={
            photo.isAccepted == false
              ? "storyUploadPreviewImg rejectedFilesContainer commentRemoveImageContainer"
              : "storyUploadPreviewImg"
          }
        >
          {photo.type && photo.type.indexOf("video") > -1 ? (
            <ReactPlayer
              url={preview}
              // controls={true}
              width="125px"
              height="69px"
            />
          ) : (
            <img src={preview} className="fileUploadSize" />
          )}
          <span
            key={preview + idx}
            onClick={() => this.removeImage(photo)}
            className="commentRemoveImage"
          >
            <span className="flaticon-trash" />
          </span>
          {/* <div className=""> */}
          {/* <span className="previewTaskImageTitle">
          {photo.name}
        </span>
        <span className="previewTaskImageTitle">
          {file_size}
        </span> */}
          {/* {photo.isAccepted==false?
        <span className="previewUploadFileError">
          The following file will not be uploaded because of its file type
        </span>
        :null} */}
          {/* </div> */}
        </span>
      );
    });
  };

  removeImage = (photo) => {
    let { setImagesPreview } = this.state;
    let { preview } = photo;
    setImagesPreview.map((el) => URL.revokeObjectURL(el.file));
    let result = setImagesPreview.filter((e) => e.preview != preview);
    URL.revokeObjectURL(preview);
    URL.revokeObjectURL(photo.file);
    this.setState({ setImagesPreview: result });
  };

  handleCreateStoryResponse = () => {
    this.setState({ disableSubmit: true });
    let {
      description,
      isAnonymous,
      mentionData,
      sanitizedDescription,
      isListChecked,
      privacy,
      title,
      mentionsSelected,
      topicsSelected,
      ogp,
      setImagesPreview,
    } = this.state;

    const formData = new FormData();
    let isUrl,
      isMention,
      mentions,
      that = this,
      newText;

    let cleanDesc = description.value ? wordFilter(description.value) : false;

    let user =
      this.props.user && this.props.user.profile
        ? this.props.user.profile
        : this.props.user;

    if (cleanDesc.length == 0) {
      newText = createUrlLink(description.value);
      newText = createMentionUrl(newText, user);
      // description.value = createUrlLink(description.value)
      // description.value = createMentionUrl(description.value, this.props.user)
      let desc = `<span>${newText}</span>`;

      if (desc.length > 0) {
        let payload = {
          description: desc,
          title,
          isAnonymous,
          privacy,
          mentionData,
        };
        formData.append("description", desc);
        formData.append("title", title);
        formData.append("mentionData", mentionData);

        formData.append("ogp", ogp);
        formData.append("isCustomList", isListChecked);

        if (
          ogp !== null &&
          Object.keys(ogp).length > 0 &&
          ogp.urlScrape !== false
        ) {
          payload.ogp = ogp;
        }

        if (isAnonymous) {
          payload.isAnonymous = isAnonymous;
          formData.append("isAnonymous", isAnonymous);
        } else if (isAnonymous === undefined) {
          payload.isAnonymous = false;
          formData.append("isAnonymous", false);
        }

        if (
          mentionData &&
          mentionData.mentions &&
          mentionData.mentions.length > 0
        ) {
          let { mentions } = mentionData;
          isMention = true;
          sanitizedDescription.userReferences = mentions.map((e) => e.id);
          payload.users = mentions.map((e) => ({
            _id: e.id,
            organizationId: user.organizationId._id,
          }));
          formData.append("users", mentions);
          payload.mentionsText = mentionData.newValue;
          formData.append("mentionsText", mentionData.newValue);
        }

        if (this.props.item && this.props.item.groupId) {
          formData.append("privacy", "GROUP");
          payload.privacy = "GROUP";
          payload.groupStory = { _id: this.props.item.groupId };
        }

        payload.story_type = 1;
        payload.parent = this.props.item._id;

        if (matchUrl(description.value)) {
          payload.isUrl = true;
          formData.append("isUrl", true);
        }

        payload.isCustomList = isListChecked;

        payload.isMention = isMention;
        formData.append("isMention", isMention);

        payload.sanitizedDescription = sanitizedDescription;
        formData.append("sanitizedDescription", sanitizedDescription);

        // payload.template = this.props.storyType
        // formData.append('template', this.props.storyType);
        // payload.topics = topicsSelected.filter(e=>e.name!=="All")
        // formData.append('topics', payload.topics);
        payload.isMobile = isMobileDevice;

        if (setImagesPreview && setImagesPreview.length > 0) {
          let sorted = setImagesPreview.sort(function(a, b) {
            return b.size - a.size;
          });
          Array.from(sorted).forEach((itm) => {
            delete itm.isAccepted;
            formData.append("uploads", itm.file);
          });
        }

        formData.append("isMobile", isMobileDevice);
        formData.append("payload", JSON.stringify(payload));

        console.log("payload ---- ", payload);

        let result = { ...payload, user: { ...user } };

        this.setState((prevState) => ({
          showResponses: [result, ...prevState.showResponses],
          showReplies: false,
          isCommentsOpen: false,
        }));

        axios.post(url.createStoryResponse, formData).then(({ data }) => {
          that.props.storyMetricsChange({ type: "replies", value: 1 });

          let result = { ...data.data, user: { ...user } };
          let prev_comments =
            this.state.showResponses.length > 0
              ? this.state.showResponses.slice(1)
              : [];
          let story_comments = [result, ...prev_comments];

          that.setState((prevState) => ({
            showResponses: story_comments,
            description: "",
            disableSubmit: false,
            title: "",
            privacy: true,
            isAnonymous: false,
            mentionsSelected: [],
            mentionsFound: [],
            setImagesPreview: [],
            mentionWord: "",
            showReplies: false,
            isCommentsOpen: false,
            responseCounter: prevState.responseCounter + 1,
          }));

          // console.log("show responses on story")
          // this.showStoryComments(item._id)
        });

        that.setState({
          showCreateStoryModal: false,
          description: "",
          title: "",
          privacy: true,
        });
      } else {
        that.setState({ showCreateStoryModal: true });
      }
    }
  };

  changeStoryCounter = (val) => {
    this.setState((prevState) => ({
      responseCounter: prevState.responseCounter + val,
    }));
  };

  handleChangeStoryDescription = (event) => {
    let descriptionContext = event.target.value;
    // let descriptionContext = event.editor.getData();
    // console.log(descriptionContext)
    // console.log(this.state.description.value)
    let word, value;

    let { mentionsFound, mentionWord } = this.state;
    if (descriptionContext === "") {
      word = [];
      value = "";
    } else {
      word = mentionsFound;
      value = mentionWord;
    }
    let valCheck = event.target.value
      .replace(/<\/?![^>]+(>|$)/g, "")
      .replace(/[\. ,:-]+/g, "")
      .replace(/^\n|\n$/g, "");

    this.setState({
      description: { value: descriptionContext },
      mentionWord: value,
      mentionsFound: word,
      disableSubmit: valCheck.length === 0,
    });
  };

  selectUserMention = (val) => {
    // console.log(val)
    // console.log(val.toString(), typeof val, JSON.parse(val))
    let obj = JSON.parse(val);
    // console.log(obj)
    this.setState((prevState) => ({
      mentionsFound: [],
      mentionWord: "",
      // description: {value: text},
      mentionsSelected: [...prevState.mentionsSelected, obj],
    }));
  };

  fetchUsers = (query, callback) => {
    let users;
    // console.log(query)
    if (!query) return;
    axios
      .get(url.findUser(query))
      .then((resp, idx) =>
        resp.data.data.map((user) => ({
          display: "@" + user.firstName + " " + user.lastName,
          id: `{ "_id": "${user._id}", "email": "${
            user.email
          }", "name": "${user.firstName + " " + user.lastName}"}`,
          // {_id:user._id, email: user.email, idx},
          // name: user.firstName + " " + user.lastName,
          // _id: user._id,
          // email: user.email,
        }))
      )
      .then(callback);
  };

  handlePermissionChange = (changeEvent) => {
    this.setState({
      isAnonymous: changeEvent.target.checked,
    });
  };

  isArchiveStory = (item, actionType) => {
    actionType === "Archive"
      ? this.archiveStory(item._id)
      : this.deArchiveStory(item._id);
    this.toggleDropdown(item._id);
  };

  archiveStory = (id) => {
    this.props.archiveStory(id);
  };

  deArchiveStory = (item) => {
    console.log(item);
    this.props.deArchiveStory(item._id);
    // axios.put(url.deArchiveStory(item._id)).then(data => {
    //   this.props.getStoryFeeds();
    //   const result = data;
    //   this.setState({
    //     dropdownOpen: false
    //   });
    // });
  };

  removeStoryConfirmation = () => {
    let { storyIdRemove, storyType } = this.state;
    let { item, user } = this.props;
    // console.log(this.props)
    // console.log("storyu -- ", storyIdRemove)
    this.setState({ showRemoveFeedConfirmationModal: false });

    if (item.userId === user.profile._id)
      this.props.storyMetricsChange({ type: "story", value: -1 });
    this.setState({
      dropdownOpen: false,
    });

    this.setState({ isRemoved: true });
    this.props.removeStoryFeeds(storyIdRemove, storyType);

    // axios.put(url.removeStoryFeeds(storyIdRemove)).then(resp => {
    // if(item.userId === user.profile._id) this.props.storyMetricsChange({type:"story", value: -1});
    // if(resp.data.data.parentStory && resp.data.data.parentStory.item && resp.data.data.type==="storyResponse"){
    //   this.setState((prevState) => ({
    //     responseCounter: prevState.responseCounter-1
    //   }))
    //   this.showStoryComments(resp.data.data.parentStory.item)
    // } else {
    //   this.props.getStoryFeeds(this.props.user);
    // }
    // });
  };

  showStoryRemoveConfirmation = (storyId, storyType) => {
    // console.log("storyu -- ", storyId)
    // this.props.showStoryRemoveConfirmation(storyId)
    // console.log(this.props)
    // console.log(storyId)
    this.setState({
      showRemoveFeedConfirmationModal: !this.state
        .showRemoveFeedConfirmationModal,
      storyIdRemove: storyId,
      storyType,
    });
  };

  closeStoryRemoveConfirmation = (storyId) => {
    this.setState({
      showRemoveFeedConfirmationModal: false,
      storyIdRemove: "",
    });
  };

  createMarkup = (input) => {
    // console.log('input---',input)
    let length = input
      .replace(/<a [\s\S]*?<\/a>/g, "")
      .replace(/<\/?[^>]+(>|$)/g, "").length;
    let start = 0;
    let end = 500;
    if (length > 500) {
      let mlength = input.replace(/<\/?[^>]+(>|$)/g, "").length;
      let oLength = input.length;
      let totalLength = oLength - mlength + end;
      // console.log('length--', totalLength, mlength, length)
      return { __html: `<div>${input.slice(start, totalLength)}...</div>` };
    } else {
      return { __html: `<div>${input}</div>` };
    }
    // if(input.length>400){
    //   input = input.slice(0,400)
    //   return { __html: `<div>${input} ...</div>` };
    // } else {
    //   return { __html: `<div>${input}</div>` };
    // }
    // return { __html: `<div>${input}</div>` };
  };

  createMarkDown = (input) => {
    let string = input;

    let length = input
      .replace(/<a [\s\S]*?<\/a>/g, "")
      .replace(/<\/?[^>]+(>|$)/g, "").length;
    let start = 0;
    let end = 500;
    if (length > 500) {
      let mlength = input.replace(/<\/?[^>]+(>|$)/g, "").length;
      let oLength = input.length;
      let totalLength = oLength - mlength + end;
      // console.log('length--', totalLength, mlength, length)
      string = input.slice(start, totalLength) + "...";
    } else {
      string = input;
    }

    let m_down = marked.parse(string, {
      breaks: true,
    });

    return m_down;
  };

  renderAsHtml = (text) => {
    return parse(this.createMarkDown(text));
  };

  createResponse = () => {
    this.setState((prevState) => ({
      showReplies: !prevState.showReplies,
      showReactions: false,
    }));
  };

  showStoryComments = (item) => {
    // console.log(item)
    // console.log("item----")
    let itm = item;
    this.setState({ showReactions: false });
    if (this.state.isCommentsOpen !== false) {
      axios.get(url.getStoryComments(itm)).then(({ data }) => {
        // console.log(data)
        let arr = data.data.storyList;
        this.setState((prevState) => ({
          showResponses: arr,
          isCommentsOpen: false,
        }));
      });
    } else {
      this.setState((prevState) => ({
        isCommentsOpen: true,
      }));
    }
  };

  showFlaggedComments = (item) => {
    console.log(item);

    let itm = item;
    this.setState({ showReactions: false });

    axios.get(url.getStoryComments(itm)).then(({ data }) => {
      // console.log(data)
      let arr = data.data.storyList;
      this.setState((prevState) => ({
        showResponses: arr,
        isCommentsOpen: false,
      }));
    });
  };

  navigateLink = (e) => {
    let className = e.target.className;
    if (isMobile && className == "userMentionWord") {
      e.preventDefault();
    }
  };

  addReaction = (val, isAnonymous) => {
    let { item, user } = this.props;
    let { reactionList, userReactions, reactionCounter } = this.state;
    // console.log(reactionCounter)
    // console.log(val)
    // console.log(user)
    let payload = {
      userId: user.profile._id,
      reaction: val,
      _id: val,
      user: user.profile,
      createdOn: new Date(),
      storyId: item._id,
      storyOwner: item.userId,
      orgId: user.profile.organizationId._id,
      isAnonymous,
    };

    // if(this.state.reactionList.indexOf(payload.userId)>-1)
    let rList = reactionList;
    let uR = userReactions;
    let isReactionListModified = false;
    let isUserListModified = false;

    rList.map((e) => {
      if (e.userId === payload.userId) {
        e.reaction = payload.reaction;
        isReactionListModified = true;
      }
    });

    uR.map((e) => {
      if (e.user._id === payload.userId) {
        e.reaction = val;
        e._id = val;
        e.user.firstName = payload.user.firstName ? payload.user.firstName : "";
        e.user.lastName = payload.user.lastName ? payload.user.lastName : "";
        e.user.profilePic = profilePicValidityCheck(payload.user.profilePic)
          ? payload.user.profilePic
          : "";
        isUserListModified = true;
      }
    });

    if (isReactionListModified) {
      this.setState((prevState) => ({
        reactionList: [...rList],
      }));
    } else {
      if (reactionList.length < 3) {
        this.setState((prevState) => ({
          reactionList: [
            { reaction: val, userId: user.profile._id },
            ...prevState.reactionList,
          ],
          reactionCounter: prevState.reactionCounter + 1,
        }));
      } else {
        this.setState((prevState) => ({
          reactionCounter: prevState.reactionCounter + 1,
        }));
      }
    }

    if (isUserListModified) {
      this.setState((prevState) => ({
        userReactions: [...uR],
        userReacted: [...uR],
      }));
    } else {
      this.setState((prevState) => ({
        userReactions: [payload, ...prevState.userReactions],
        userReacted: [payload, ...prevState.userReactions],
      }));
    }

    axios.post(url.addReaction(item._id), payload).then(({ data }) => {
      // console.log(data)
      this.props.storyMetricsChange({ type: "reactions", value: 1 });
    });
  };

  pickImage = (val) => {
    let selected = storyReactions.filter((x) => x._id === val)[0];
    return selected && selected.image;
  };

  reportedModalId = (val) => {
    this.setState({ reportedModalId: val });
  };

  showReactionList = () => {
    const { item } = this.props;
    axios.get(url.userReactions(item._id)).then(({ data }) => {
      // console.log(data.data, this.state.userReactions)
      let value = data.data;
      if (value.storyList && value.storyList.length > 0) {
        this.setState((prevState) => ({
          showUserReactions: true,
          userReactions: [...value.storyList],
        }));
      } else if (this.state.userReactions.length > 0) {
        this.setState((prevState) => ({
          showUserReactions: true,
          userReactions: [...prevState.userReactions],
        }));
      }
    });
  };

  removeReactionHover = () => {
    // console.log('counter---', this.state.reactionCounter)
    this.setState((prevState) => ({
      showReactions: false,
    }));
  };

  closeReactionModal = () => {
    this.setState({ showUserReactions: false });
  };

  seeStory = (item) => {
    let result;
    if (this.props.group && this.props.group._id) {
      console.log("group");
      let { group } = this.props;
      result = {
        groupStory: {
          name: group.name,
          groupId: group._id,
          storyId: item._id,
        },
      };

      this.props.onProfileUpdate(result);
    }

    if (isMobile && this.props.openMobilePopupFromGroups) {
      console.log("mobile---");
      const { path } = this.props.match;
      const isMyStories = path.includes("/stories/me");

      const url = `/home/stories/${item._id}?${isMyStories && "me"}`;

      this.setState({
        showStoryDetailsPopup: true,
        storyDetailsPopupPath: url,
        singleStoryPopupId: item._id,
      });
    } else {
      console.log("singlestory");
      const { path } = this.props.match;
      const isMyStories = path.includes("/stories/me");
      let story_url = `/home/stories/${item._id}?${isMyStories && "me"}`;

      this.props.history.push(story_url);

      // console.log('url ---- ', story_url )

      // this.props.history.push({
      //   pathname: story_url,
      //   state: {
      //     category: result,
      //   },
      // });
    }
  };

  removeReaction = () => {
    // console.log("remove reaction")
    let userId = this.props.user.profile._id;
    let storyId = this.props.item._id;
    let userRlist =
      this.state.userReacted && this.state.userReacted !== null
        ? this.state.userReacted
        : this.state.userReactions;
    let reactionList = this.state.reactionList;
    // console.log(userRlist, this.props.user.profile, reactionList)
    // console.log(this.state.userReacted, this.state.userReactions)

    if (userRlist.length > 0) {
      // console.log(userRlist)
      let ulist = userRlist.filter(
        (e) => e.userId != this.props.user.profile._id
      );
      // console.log(ulist)
      this.setState((prevState) => ({
        userReacted: [...ulist],
        userReactions: [...ulist],
      }));
    }

    if (reactionList.length > 0) {
      let rlist = reactionList.filter(
        (e) => e.userId != this.props.user.profile._id
      );
      // console.log(rlist)
      this.setState((prevState) => ({
        reactionList: [...rlist],
        reactionCounter: prevState.reactionCounter - 1,
      }));
    }

    axios.delete(url.deleteReaction(storyId, userId)).then(({ data }) => {
      this.props.storyMetricsChange({ type: "reactions", value: -1 });

      // console.log(data)
    });
  };

  showTopicName = (topic) => {
    let { filters } = this.props;
    // console.log(filters)
    if (topic) {
      let res = filters.filter((e) => e._id === topic._id);
      if (res && res[0]) {
        return res[0].name;
      }
    }
  };

  editStory = (story) => {
    // console.log(story)
    this.props.showCreateStory();
  };

  goToProfile = (profilePicSrc) => {
    if (isMobile) return;
    let link = "";
    console.log(this.props);
    // console.log(this.props.officeMate)
    if (this.props.item.userId === this.props.user.profile._id) {
      // dynamic_urls
      this.props.history.push(
        `/home/${this.props.item.organizationId}/profile/${this.props.item.userId}`
      );
    } else {
      this.props.history.push(
        `/home/${this.props.item.organizationId}/profile/${this.props.item.userId}`
      );
    }
  };

  returnSiteName = () => {
    const { item } = this.props;
    if (item) {
      if (item.ogp && item.ogp !== "undefined" && item.ogp !== null) {
        let { ogp } = item;

        let { ogUrl, twitterAppNameGooglePlay, ogSiteName } = ogp;

        let startNameURL = ogUrl.indexOf("w.") + 2;
        let endNameURL = ogUrl.indexOf(".com");
        let startEndDiff = endNameURL - startNameURL;
        let siteName = ogUrl.substr(startNameURL, startEndDiff);

        if (ogSiteName) {
          return ogSiteName;
        } else if (twitterAppNameGooglePlay) {
          return twitterAppNameGooglePlay;
        } else {
          return siteName;
        }
      }
    }
  };

  handleClick = (event) => {
    const { target = {} } = event || {};
    target.value = "";
  };

  openCarouselModal = (type) => {
    let res = [],
      { item } = this.props;
    if (type == "i") {
      let obj = { url: item.image };
      res.push(obj);
    } else {
      res = [...item.attachments];
    }
    this.setState((prevState) => ({
      isCarouselModal: !prevState.isCarouselModal,
      carouselData: res,
    }));
  };

  getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  canSubmit = (val) => {
    this.setState({ ...val });
    // this.setState({disableSubmit:val})
  };

  closeCarousel = () => {
    this.setState({ isCarouselModal: false });
  };

  renderStoryAuthor = (item) => {
    let { user, renderFlagged } = this.props;

    if (!renderFlagged) {
      if (item.isAnonymous) {
        let text = <span>Anonymous user</span>;
        let u_doc = user.profile;
        if (user && u_doc && u_doc._id && u_doc._id == item.userId) {
          return (
            <span>
              Anonymous user <span className="storyDate">(you)</span>
            </span>
          );
        } else {
          return text;
        }
      } else {
        if (item.user && item.user.firstName) {
          let { firstName, lastName } = item.user;
          return firstName + " " + lastName;
        }
        else if(item.user && item.user.status =="INACTIVE"){
          return "Deactivated user"
        }
        else {
          return item.fullname;
        }
      }
    } else {
      if (item.isAnonymous) {
        let text = <span>Anonymous user</span>;
        let u_doc = user.profile;
        if (user && u_doc && u_doc._id && u_doc._id == item.userId._id) {
          return (
            <span>
              Anonymous user <span className="storyDate">(you)</span>
            </span>
          );
        } else {
          return text;
        }
      } else {
        if (item.userId && item.userId.firstName) {
          let { firstName, lastName } = item.userId;
          return firstName + " " + lastName;
        } else {
          return item.fullname;
        }
      }
    }

    // {item.isAnonymous ? 'Anonymous user'
    // : item.fullname
    // }
  };

  // reactionListTitle
  render_user_pic = (item) => {
    const { renderFlagged } = this.props;
    if (!renderFlagged) {
      if (item.isAnonymous) {
        return (
          <img src={avatarIcon} className="userReactionPic noPointer" alt="" />
        );
      } else if (
        item.user &&
        profilePicValidityCheck(item.user.profilePic) &&
        item.user.profilePic.length > 0
      ) {
        return (
          <img
            onClick={this.goToProfile}
            // className="grp_create_search_user_pic"
            className="userReactionPic"
            src={item.user.profilePic}
          />
        );
      } else if (item.user && item.user.firstName) {
        return (
          <span
            className="spotlightUserInitials"
            onClick={this.goToProfile}
            data-letters={this.getInitials(item.user)}
          />
        );
      }
    } else {
      if (item.isAnonymous) {
        return <img src={avatarIcon} className="avatar-pic noPointer" alt="" />;
      } else if (
        item.userId &&
        profilePicValidityCheck(item.userId.profilePic) &&
        item.userId.profilePic.length > 0
      ) {
        return (
          <img
            onClick={this.goToProfile}
            className="grp_create_search_user_pic"
            src={item.userId.profilePic}
          />
        );
      } else if (item.userId && item.userId.firstName) {
        return (
          <span
            className="spotlightUserInitials"
            onClick={this.goToProfile}
            data-letters={this.getInitials(item.userId)}
          />
        );
      }
    }
  };

  groupActionRoleCheck = () => {
    const { currentRole } = this.props;
    const { orgAdmin } = this.props.user.profile;
    if (currentRole && currentRole == -1 && orgAdmin) {
      return false;
    } else if (currentRole && currentRole == -1) {
      return true;
    }
  };

  renderFlaggedBy = (item) => {
    if (
      item.isFlagged &&
      item.isFlagged.status &&
      !isEmpty(item.isFlagged.user)
    ) {
      const flagDoc = item.isFlagged;

      if (flagDoc.isAnonymous) {
        return "Anonymous User";
      } else {
        return `${flagDoc.user.firstName || ""} ${flagDoc.user.lastName || ""}`;
      }
    } else {
      return "";
    }
  };

  renderFlaggedDate = (item) => {
    if (
      item.isFlagged &&
      item.isFlagged.status &&
      !isEmpty(item.isFlagged.date)
    ) {
      const flagDoc = item.isFlagged;

      return moment(flagDoc.date).format("MMMM D, YYYY");
    } else {
      return "";
    }
  };

  renderStories = () => {
    const isAdmin =
      this.props.user.profile.role === "Admin" ||
      this.props.user.profile.role === "SuperAdmin";
    const list = orderBy(this.state.stories, "createdOn", "desc");
    const { orgAdmin } = this.props.user.profile;

    let { item, actionType, avatar, currentRole } = this.props;
    let itemTemplate = storyTemplates.filter((val) => {
      if (item.template && item.template._id) {
        return item.template._id === val._id ? val : null;
      } else {
        return null;
      }
    });
    let {
      isCommentsOpen,
      ogp,
      description,
      showUserReactions,
      isAnonymous,
      isVideo,
      disableCreate,
      disableSubmit,
      reactionList,
      showResponses,
      setImagesPreview,
      responseCounter,
      shareOpen,
      showSlackShare,
      showTeamsShare,
    } = this.state;

    let isArchived = item.isArchived || item.isDeleted ? true : false;
    if (isArchived) {
      actionType = "Restore";
    } else {
      actionType = "Archive";
    }
    let profilePicture = item.profilePic ? item.profilePic : avatarIcon;
    // console.log(itemTemplate, item)
    const createStoryModalStyle = classnames(
      "addStoryComment btn btn-primary",
      {
        disabled: disableSubmit,
      }
    );
    // console.log('attachments: ', item.attachments)

    let canRemoveStoryFromGroup = false;
    if (this.props.group && this.props.group.createdBy) {
      canRemoveStoryFromGroup =
        this.props.group.createdBy._id === this.props.user.profile._id ||
        [0, 1, 2].includes(currentRole);
    }

    const renderFlagged = this.props.renderFlagged
      ? true
      : item.isFlagged && item.isFlagged.status;

    const storyIsShared =
      item.sharedWith && item.sharedWith.length > 0
        ? item.sharedWith.length
        : 0;

    let isStorySharedWithOrgAdmin = false;
    if (orgAdmin && storyIsShared) {
      const orgAdminShared = item.sharedWith.find(
        (x) => x.userId === this.props.user.profile._id
      );
      if (orgAdminShared) {
        isStorySharedWithOrgAdmin = true;
      }
    }

    let isPostOwner = false;

    if (item.user && item.user._id) {
      isPostOwner = this.props.user.profile._id === item.user._id;
    } else if (item.userId && item.userId._id) {
      isPostOwner = this.props.user.profile._id === item.userId._id;
    }

    const isMyStoriesPage = window.location.pathname.includes("/me");
    return (
      // ml-3
      <div className={`${renderFlagged ? "single-flagged-stories" : ""}`}>
        <ListGroupItem
          className={`${!isMobile && ""} ${item.isTrending && ""} story-list`}
          key={item._id}
        >
          <div className="avatar">
            {this.render_user_pic(item)}
            <span className="storyOwner">
              <span className="storyUsername">
                {this.renderStoryAuthor(item)}
              </span>
              <span className="user_gender_pronoun_story ml-1">
                {item.isAnonymous ? (
                  ""
                ) : (
                  <span>{renderGenderPronoun(item.user)}</span>
                )}
              </span>
              {storyIsShared > 0 && !orgAdmin ? (
                <span className="storySharedText ml-1">
                  {storyIsShared == 1
                    ? isPostOwner
                      ? "shared this post with 1 other employee"
                      : "shared this post with You"
                    : isPostOwner
                    ? `
                  shared this post with  ${storyIsShared} ${
                        storyIsShared > 1 ? "other employees" : "other employee"
                      }
                  `
                    : `shared this post with You and ${storyIsShared - 1} ${
                        storyIsShared > 2 ? "other employees" : "other employee"
                      }`}
                </span>
              ) : storyIsShared > 0 && orgAdmin && isStorySharedWithOrgAdmin ? (
                <span className="storySharedText ml-1">
                  {storyIsShared == 1
                    ? `shared this post with You`
                    : `shared this post with You and ${storyIsShared - 1} ${
                        storyIsShared > 2 ? "other employees" : "other employee"
                      }`}
                </span>
              ) : storyIsShared > 0 &&
                orgAdmin &&
                !isStorySharedWithOrgAdmin ? (
                <span className="storySharedText ml-1">
                  {storyIsShared == 1
                    ? `shared this post with 1 employee`
                    : `shared this post with ${storyIsShared} employees`}
                </span>
              ) : (
                ""
              )}
              <br />
              <span className="storyDate">
                {moment(item.createdOn).format("MMM D, YYYY")}

                {item.isDani && (
                  <img src={DaniIcon} className="story-isdani-logo" />
                )}
              </span>
            </span>
          </div>

          {!isMyStoriesPage && renderFlagged && (
            <div className="story-flaggedby-div">
              {" "}
              Flagged by <b>{this.renderFlaggedBy(item)}</b> On{" "}
              <b>{this.renderFlaggedDate(item)}</b>
            </div>
          )}

          {isMobile ? (
            <div className="story-scroll-horizontal">
              {itemTemplate && itemTemplate != [] && itemTemplate.length > 0 ? (
                <div
                  className="storyTopics itemTemplate"
                  style={{
                    backgroundColor: itemTemplate[0].color,
                    color: "black",
                    border: itemTemplate[0].border,
                  }}
                >
                  {/* <img src={e.image} className="templateImage"/> */}
                  {itemTemplate[0].name}
                </div>
              ) : null}

              <StoryCatsMobile item={item} showTopicName={this.showTopicName} />
            </div>
          ) : (
            <div>
              {itemTemplate && itemTemplate != [] && itemTemplate.length > 0 ? (
                <div
                  className="storyTopics itemTemplate"
                  style={{
                    backgroundColor: itemTemplate[0].color,
                    color: "black",
                    border: itemTemplate[0].border,
                  }}
                >
                  {/* <img src={e.image} className="templateImage"/> */}
                  {itemTemplate[0].name}
                </div>
              ) : null}

              {item.topics && item.topics.length > 0
                ? item.topics.map((topic, idx) => {
                    return (
                      <div className="storyTopics" key={idx}>
                        {this.showTopicName(topic)}
                      </div>
                    );
                  })
                : null}
            </div>
          )}

          <div
            className="story-list col-xs-12"
            onClick={(e) => this.navigateLink(e)}
            id={`story_export_${item._id}`}
          >
            <div
              className={`${isMobile && "mb-0"} mainStoryContent`}
              // dangerouslySetInnerHTML={this.createMarkup(
              //   // item.description.replace(/\n/g, "<br />")
              //   item.description
              // )}
            >
              {this.renderAsHtml(item.description)}
            </div>
            {item.description &&
            item.description
              .replace(/<a [\s\S]*?<\/a>/g, "")
              .replace(/<\/?[^>]+(>|$)/g, "").length > 500 ? (
              <span
                className="singleStory display-block"
                onClick={() => this.seeStory(item)}
              >
                see more
              </span>
            ) : null}

            {item &&
            item.ogp &&
            item.ogp !== null &&
            item.ogp !== "undefined" &&
            item.ogp.hasOwnProperty("urlScrape") &&
            item.ogp.urlScrape &&
            isVideo != true &&
            item.attachments &&
            item.attachments.length == 0 ? (
              <div className="ogContainer">
                <a className="ogHref" href={item.ogp.ogUrl} target="_blank">
                  {item.ogp.ogImage && item.ogp.ogImage.url ? (
                    <span className="story_image_full_container">
                      <div
                        className="event_details_bg_image_blur"
                        style={{
                          backgroundImage: `url(${item.ogp.ogImage.url})`,
                        }}
                      />
                      <img src={item.ogp.ogImage.url} className="ogImage" />
                    </span>
                  ) : null}

                  <div className="ogContent">
                    <span className="ogSite">{this.returnSiteName()}</span>
                    <span className="ogTitle">{item.ogp.ogTitle}</span>
                  </div>
                </a>
              </div>
            ) : null}

            {isVideo ? (
              <div className="imgFixContainer">
                <ReactPlayer
                  width="100%"
                  controls={true}
                  url={item.ogp.ogUrl}
                />
              </div>
            ) : null}

            {item.attachments && item.attachments.length > 0 ? (
              <span onClick={() => this.openCarouselModal("a")}>
                <StoriesPhotoGrid attachments={item.attachments} />
              </span>
            ) : null}

            {item.image && item.attachments && item.attachments.length == 0 ? (
              <div className="imgFixContainer">
                <span className="story_image_full_container">
                  <div
                    className="event_details_bg_image_blur"
                    style={{ backgroundImage: `url(${item.image})` }}
                  />
                  <img
                    //  onClick={()=> this.seeStory(item)}
                    onClick={() => this.openCarouselModal("i")}
                    src={item.image}
                    className="imgFix imgCursor"
                  />
                </span>
              </div>
            ) : null}
          </div>

          {this.state.isCarouselModal ? (
            <StoriesPhotoCarousel
              closeCarousel={this.closeCarousel}
              attachments={this.state.carouselData.sort(function(a, b) {
                return b.size - a.size;
              })}
              // attachments={item.attachments}
              showCarousel={this.state.isCarouselModal}
            />
          ) : null}

          {!renderFlagged && (
            <div
              className={`reactionsHover story-reaction-align ${
                currentRole && currentRole == -1 ? "group_role_disabled" : ""
              }`}
            >
              <div className="comment-action-item">
                {isArchived === true ? null : currentRole &&
                  currentRole == -1 ? (
                  <span
                    className={`like-inline${
                      currentRole && currentRole == -1
                        ? "group_role_disabled"
                        : ""
                    }`}
                  >
                    <img src={likeHover} className="mr-1" /> Like
                  </span>
                ) : (
                  <Reactions
                    removeReaction={this.removeReaction}
                    saveReaction={this.addReaction}
                    hideReactions={this.state.showReactions}
                    userReacted={this.state.userReacted}
                  />
                )}
              </div>

              <div className="comment-action-item mr-2">
                {isArchived === true ? null : (
                  <div
                    className={`replyStory ${
                      currentRole && currentRole == -1
                        ? "group_role_disabled"
                        : ""
                    }`}
                    onClick={
                      currentRole && currentRole == -1
                        ? null
                        : this.createResponse
                    }
                  >
                    <IoChatboxOutline size={"24px"} color="gray" />
                    {!isMobile ? "Comment" : "  Leave a comment"}
                  </div>
                )}
              </div>

              <ShareStory
                item={item}
                user={this.props.user}
                entityType="STORY"
                display="POPPER"
              />
            </div>
          )}

          {/*Story owner cant see this option */}
          {this.props.user.profile._id !== item.userId || renderFlagged ? (
            <div>
              {currentRole && currentRole !== -1 ? (
                <ReportStoryModal
                  story={item}
                  isReportedItem={this.reportedModalId}
                  handleFlagSuccess={this.onStoryEditSuccess}
                  renderFlagged={this.props.renderFlagged}
                  handleUnflagSuccess={this.onStoryEditSuccess}
                  orgAdmin={orgAdmin}
                />
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
          {!renderFlagged ? (
            <Dropdown
              isOpen={
                this.groupActionRoleCheck()
                  ? false
                  : this.state.dropdownOpen === item._id ||
                    this.state.reportedModalId == item._id
                  ? true
                  : false
              }
              toggle={
                this.groupActionRoleCheck()
                  ? false
                  : () => this.toggleDropdown(item._id)
              }
              className={`wwDropdown ${
                this.groupActionRoleCheck() ? "group_role_disabled" : ""
              }`}
            >
              <DropdownToggle
                tag="span"
                className="chart-item-menu cursor-pointer"
                onClick={() => this.toggleDropdown(item._id)}
                data-toggle="dropdown"
                aria-expanded={
                  this.state.dropdownOpen === item._id ? true : false
                }
              >
                <BiDotsHorizontalRounded size={"26px"} color="gray" />
                {/*<i className={`chart-item-menu ${ isMobile ? 'flaticon-down' : 'flaticon-menu-1'}`} style={{ cursor: 'pointer' }}></i>*/}
              </DropdownToggle>

              <If
                condition={
                  orgAdmin ||
                  this.props.user.profile._id === item.userId ||
                  this.props.user
                }
              >
                <DropdownMenu
                  right
                  className="chart-dropdown"
                  style={{ padding: "0" }}
                >
                  <div>
                    {/* {isArchived!==true?
                    <If condition={ this.props.user.profile._id === item.userId}>
                    <div className="chart-list-dropdown-options"
                      style={{ display: 'flex' }}
                      onClick={() => this.editStory(item)}
                      >
-
                      <i className="chart-item-menu flaticon-edit"></i>
                        <span  className="chart-list-dropdown-options-text">
                          Edit
                        </span>
                    </div>
                  </If>
-
                    :
                    null
-
                    } */}

                    <div
                      className="chart-list-dropdown-options"
                      style={{ display: "flex" }}
                      onClick={() => this.seeStory(item)}
                    >
                      <i className="story-item flaticon-vision"></i>
                      <span className="chart-list-dropdown-options-text">
                        See post
                      </span>
                    </div>

                    {!isArchived &&
                    this.props.user.profile._id === item.userId ? (
                      <div
                        className="chart-list-dropdown-options"
                        style={{ display: "flex" }}
                        onClick={() => this.openStoryEditPopup(item)}
                      >
                        <i className="chart-item-menu flaticon-edit"></i>
                        <span className="chart-list-dropdown-options-text">
                          Edit Story
                        </span>
                      </div>
                    ) : null}

                    {this.props.user.profile._id !== item.userId ||
                    renderFlagged ? (
                      <div className="chart-list-dropdown-options">
                        <ReportStoryModal
                          isTextOnly={true}
                          story={item}
                          isReportedItem={this.reportedModalId}
                          handleFlagSuccess={this.onStoryEditSuccess}
                          renderFlagged={this.props.renderFlagged}
                          handleUnflagSuccess={this.onStoryEditSuccess}
                          orgAdmin={orgAdmin}
                        />
                      </div>
                    ) : (
                      ""
                    )}

                    {isArchived === true ? (
                      <span>
                        <If
                          condition={
                            isAdmin ||
                            this.props.user.profile._id === item.userId
                          }
                        >
                          <div>
                            <If
                              condition={
                                this.props.user.profile._id === item.userId
                              }
                            >
                              <div
                                className="chart-list-dropdown-options"
                                style={{ display: "flex" }}
                                onClick={() =>
                                  this.deArchiveStory(item, actionType)
                                }
                              >
                                <i className="chart-item-menu flaticon-update"></i>
                                <span className="chart-list-dropdown-options-text">
                                  Restore
                                </span>
                              </div>
                            </If>
                          </div>
                        </If>
                        <If
                          condition={
                            orgAdmin ||
                            this.props.user.profile._id === item.userId ||
                            canRemoveStoryFromGroup
                          }
                        >
                          <div
                            className="chart-list-dropdown-options"
                            style={{ display: "flex" }}
                            onClick={() =>
                              this.showStoryRemoveConfirmation(
                                item._id,
                                "Story"
                              )
                            }
                          >
                            <i className="chart-item-menu flaticon-minus"></i>
                            <span className="chart-list-dropdown-options-text">
                              Remove from Feed
                            </span>
                          </div>
                        </If>
                      </span>
                    ) : (
                      <div>
                        <If
                          condition={
                            orgAdmin ||
                            this.props.user.profile._id === item.userId ||
                            canRemoveStoryFromGroup
                          }
                        >
                          <div
                            className="chart-list-dropdown-options"
                            style={{ display: "flex" }}
                            onClick={() =>
                              this.showStoryRemoveConfirmation(
                                item._id,
                                "Story"
                              )
                            }
                          >
                            <i className="chart-item-menu flaticon-minus"></i>
                            <span className="chart-list-dropdown-options-text">
                              Remove from Feed
                            </span>
                          </div>
                        </If>

                        <If
                          condition={
                            this.props.user.profile._id === item.userId
                          }
                        >
                          <div
                            className="chart-list-dropdown-options"
                            style={{ display: "flex" }}
                            onClick={() =>
                              this.isArchiveStory(item, actionType)
                            }
                          >
                            <If condition={actionType === "Restore"}>
                              <i className="chart-item-menu flaticon-update"></i>
                            </If>
                            <If condition={actionType === "Archive"}>
                              <i className="chart-item-menu flaticon-trash"></i>
                            </If>
                            <span className="chart-list-dropdown-options-text">
                              {actionType}
                            </span>
                          </div>
                        </If>
                      </div>
                    )}
                  </div>
                </DropdownMenu>
              </If>
            </Dropdown>
          ) : (
            <Dropdown
              isOpen={
                this.groupActionRoleCheck()
                  ? false
                  : this.state.dropdownOpen === item._id ||
                    this.state.reportedModalId == item._id
                  ? true
                  : false
              }
              toggle={
                this.groupActionRoleCheck()
                  ? false
                  : () => this.toggleDropdown(item._id)
              }
              className={`wwDropdown ${
                isMyStoriesPage ? "" : "wwDropdown-t-align"
              }  ${this.groupActionRoleCheck() ? "group_role_disabled" : ""}`}
            >
              <DropdownToggle
                tag="span"
                className="chart-item-menu cursor-pointer"
                onClick={() => this.toggleDropdown(item._id)}
                data-toggle="dropdown"
                aria-expanded={
                  this.state.dropdownOpen === item._id ? true : false
                }
              >
                <BiDotsHorizontalRounded size={"26px"} color="gray" />
                {/*<i className={`chart-item-menu ${ isMobile ? 'flaticon-down' : 'flaticon-menu-1'}`} style={{ cursor: 'pointer' }}></i>*/}
              </DropdownToggle>

              <If
                condition={
                  orgAdmin ||
                  this.props.user.profile._id === item.userId ||
                  this.props.user
                }
              >
                <DropdownMenu
                  right
                  className="chart-dropdown"
                  style={{ padding: "0" }}
                >
                  <div>
                    {/* {isArchived!==true?
                  <If condition={ this.props.user.profile._id === item.userId}>
                  <div className="chart-list-dropdown-options"
                    style={{ display: 'flex' }}
                    onClick={() => this.editStory(item)}
                    >
-
                    <i className="chart-item-menu flaticon-edit"></i>
                      <span  className="chart-list-dropdown-options-text">
                        Edit
                      </span>
                  </div>
                </If>
-
                  :
                  null
-
                  } */}

                    <div
                      className="chart-list-dropdown-options"
                      style={{ display: "flex" }}
                      onClick={() => this.seeStory(item)}
                    >
                      <i className="story-item flaticon-vision"></i>
                      <span className="chart-list-dropdown-options-text">
                        See post
                      </span>
                    </div>

                    {this.props.user.profile._id !== item.userId ||
                    renderFlagged ? (
                      <div className="chart-list-dropdown-options">
                        <ReportStoryModal
                          isTextOnly={true}
                          story={item}
                          isReportedItem={this.reportedModalId}
                          handleFlagSuccess={this.onStoryEditSuccess}
                          renderFlagged={this.props.renderFlagged}
                          handleUnflagSuccess={this.onStoryEditSuccess}
                          orgAdmin={orgAdmin}
                        />
                      </div>
                    ) : (
                      ""
                    )}

                    <If
                      condition={
                        orgAdmin ||
                        this.props.user.profile._id === item.userId ||
                        canRemoveStoryFromGroup
                      }
                    >
                      <div
                        className="chart-list-dropdown-options"
                        style={{ display: "flex" }}
                        onClick={() =>
                          this.showStoryRemoveConfirmation(item._id, "Story")
                        }
                      >
                        <i className="chart-item-menu flaticon-minus"></i>
                        <span className="chart-list-dropdown-options-text">
                          Remove from Feed
                        </span>
                      </div>
                    </If>
                  </div>
                </DropdownMenu>
              </If>
            </Dropdown>
          )}

          {!renderFlagged && (
            <div className="storyOptionsContainer">
              {this.state.reactionList && this.state.reactionList.length > 0 ? (
                <div
                  onClick={this.showReactionList}
                  className="reactionsContainer"
                >
                  {this.state.reactionList.map((e, idx) => {
                    return (
                      <img
                        className="reactionItems"
                        src={this.pickImage(e.reaction)}
                        key={idx}
                      />
                    );
                  })}
                  <span className="reactionCounter">
                    {this.state.reactionCounter}
                  </span>
                </div>
              ) : (
                <span className="noReactions">No Reactions</span>
              )}
              {/* <span> | </span> */}
              {responseCounter > 0 ? (
                <span
                  className="viewComments"
                  onClick={() => this.seeStory(item)}
                >
                  {responseCounter === 1
                    ? `1 Comment`
                    : `${responseCounter} Comments`}
                </span>
              ) : (
                <span className="noReplies">No Comments</span>
              )}
            </div>
          )}

          {!renderFlagged && this.state.showUserReactions ? (
            <Modal
              isOpen={this.state.showUserReactions}
              className="archive-modal show-user-reactions"
            >
              <ModalBody>
                <div className="modal-title reactionListTitle">
                  {this.state.userReactions.length} Reactions
                </div>
                <div className="modal-content-wrapper word-break reactionModal">
                  {this.state.userReactions &&
                  this.state.userReactions.length > 0
                    ? this.state.userReactions.map((e, idx) => {
                        return (
                          <div className="userReactionContainer" key={idx}>
                            <div>
                              {this.render_user_pic(e)}
                              {e.isAnonymous ? (
                                <span className="userReactionName">
                                  {" "}
                                  {this.props.user.profile._id != e.userId
                                    ? "Anonymous user"
                                    : "You (anonymous)"}{" "}
                                </span>
                              ) : (
                                <span className="userReactionName">
                                  {e.user.firstName} {e.user.lastName}
                                </span>
                              )}
                            </div>

                            <img
                              className="reactionModalImage"
                              src={this.pickImage(e._id)}
                            />
                          </div>
                        );
                      })
                    : null}
                </div>

                <Row
                  className={`mt30 ${isMobile && "reaction-close"}`}
                  style={{ marginLeft: "9px" }}
                >
                  <Col sm={{ size: 4 }} md={{ size: 4 }}>
                    <Button
                      className="archive-button"
                      onClick={this.closeReactionModal}
                    >
                      Close
                    </Button>{" "}
                  </Col>
                  {/* <Col sm={{ size: 4 }} md={{ size: 4 }}>
                      <Button className="cancel-button float-right" onClick={this.closeReactionModal}>
                          Cancel
                      </Button>
                    </Col> */}
                </Row>
              </ModalBody>
            </Modal>
          ) : null}

          {!renderFlagged && this.state.showReplies ? (
            <div className="mentionsReplyInput">
              <span
                className="post-comment-me"
                style={{ position: "absolute" }}
              >
                {this.render_user_pic({ user: this.props.user.profile })}
              </span>
              <StoryMentionsText
                isModule="GROUP"
                storyLimit={2000}
                groupObj={this.props.group}
                canSubmit={this.canSubmit}
                storyType={"Write a comment..."}
              />

              <Button
                className={createStoryModalStyle}
                onClick={this.handleCreateStoryResponse}
              >
                <span className="profile-modal-save-btn-txt">
                  {" "}
                  Post
                  {/*<span className="ml10 flaticon-tick"></span>*/}
                </span>
              </Button>

              <span className="mentionsStoryCamera">
                <label
                  htmlFor="profile-pic-file-input"
                  style={{ marginBottom: "0px" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className=""
                    viewBox="0 0 16 16"
                  >
                    <path d="M10.5 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"></path>
                    <path d="M2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2zm.5 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm9 2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z"></path>
                  </svg>
                </label>
                <input
                  id="profile-pic-file-input"
                  onClick={!disableCreate ? this.handleClick : null}
                  onChange={this.fileSelectedHandler}
                  type="file"
                  multiple
                />
              </span>

              <div>
                {setImagesPreview && setImagesPreview.length > 0 ? (
                  <div className="taskUploadPreviewContainer mb0 commentImageSectionContainer">
                    <div className="taskUploadPreviewContainerOverflow commentImageSectionRow">
                      {this.renderUploadPreview(setImagesPreview)}
                    </div>
                  </div>
                ) : null}
              </div>

              <div
                className="anonymousStoryResponse"
                hidden={!this.state.isAnonymousVisible}
              >
                <span className="permission-value ml10">Anonymous</span>
                <span className="ml5">
                  <Toggle
                    checked={isAnonymous}
                    icons={false}
                    onChange={this.handlePermissionChange}
                  />
                </span>
              </div>
            </div>
          ) : null}

          {showResponses && showResponses.length > 0 ? (
            <div
              className={isCommentsOpen === false ? "storyItemsContainer" : ""}
            >
              {showResponses.map((e, idx) => {
                if (e && !e.hasOwnProperty("_id")) {
                  e._id = new Date();
                }
                if (e.isDeleted !== true) {
                  const avatar = e.isAnonymous
                    ? avatarIcon
                    : profilePicValidityCheck(e.profilePic)
                    ? e.profilePic
                    : avatarIcon;
                  return (
                    <div key={e._id + idx}>
                      <StoryCommentList
                        orgAdmin={orgAdmin}
                        user={this.props.user}
                        isCommentsOpen={isCommentsOpen}
                        showStoryComments={
                          renderFlagged
                            ? this.showFlaggedComments
                            : this.showStoryComments
                        }
                        removeCommentConfirmation={
                          this.showStoryRemoveConfirmation
                        }
                        key={e._id}
                        changeStoryCounter={this.changeStoryCounter}
                        actionType={this.props.actionType}
                        item={e}
                        avatar={avatar}
                      />
                    </div>
                  );
                }
              })}
            </div>
          ) : null}
        </ListGroupItem>
      </div>
    );
  };

  getStoriesCount = () => {
    const filteredStories = this.state.stories.filter(
      (story) => !story.isDeleted
    );
    return filteredStories.length;
  };

  handleCollapse = () => {
    this.setState((state) => ({ collapseCompleted: !state.collapseCompleted }));
  };

  renderContent = () => {
    let {
      showRemoveFeedConfirmationModal,
      isRemoved,
      editPopupOpen,
      editStoryPopupObj,
    } = this.state;
    if (!isRemoved) {
      return (
        <div className="stories" onMouseLeave={this.removeReactionHover}>
          {this.renderStories()}

          {editPopupOpen && (
            <EditStory
              editPopupOpen={editPopupOpen}
              toggleEditPopup={this.closeStoryEditPopup}
              storyId={editStoryPopupObj._id}
              story={editStoryPopupObj}
              {...this.props}
              onEditSuccess={this.onStoryEditSuccess}
            />
          )}

          <Modal
            isOpen={showRemoveFeedConfirmationModal}
            className="archive-modal remove-story-model"
          >
            <ModalBody>
              <div className="modal-title">
                Remove {this.state.storyType}
                <span
                  className="model-close"
                  onClick={this.closeStoryRemoveConfirmation}
                >
                  <i className="flaticon-close"></i>
                </span>
              </div>
              <div className="modal-content-wrapper word-break">
                You are about to remove a {this.state.storyType || "story"}.
                This action is irreversible and will completely delete the
                Story. <br />
                No one, including the author of the comment, will be able to see
                it any more.
              </div>
              <Row
                className="mt30 remove-story-buttons"
                style={{ marginLeft: "9px" }}
              >
                <Col sm={{ size: 4 }} md={{ size: 4 }}>
                  <Button
                    className="archive-button"
                    onClick={this.removeStoryConfirmation}
                  >
                    Remove Post
                  </Button>{" "}
                </Col>
                <If condition={!isMobile}>
                  <Col sm={{ size: 4 }} md={{ size: 4 }}>
                    <Button
                      className="cancel-button float-right"
                      onClick={this.closeStoryRemoveConfirmation}
                    >
                      Cancel
                    </Button>
                  </Col>
                </If>
              </Row>
            </ModalBody>
          </Modal>
          {this.state.showStoryDetailsPopup && (
            <Modal
              isOpen={this.state.showStoryDetailsPopup}
              toggle={this.toggleStoryDetailsPopup}
            >
              <ModalHeader toggle={this.toggleStoryDetailsPopup}>
                View Story
              </ModalHeader>
              <ModalBody>
                <SingleStory
                  storyGroupId={this.state.singleStoryPopupId}
                  history={{ ...this.props.history }}
                />
              </ModalBody>
            </Modal>
          )}
        </div>
      );
    } else {
      return null;
    }
  };

  render() {
    return this.renderContent();
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    storyMetricsChange: (data) =>
      dispatch(actionCreators.storyMetricsChange(data)),
    onKpiMasterListFetched: (data) =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(StoryItems, axios)));
